module.exports = __webpack_public_path__ + "img/triangle.37262e58.svg";